// SPDX-FileCopyrightText: 2026 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2026 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

type CounterBoxProps = {
  label: string
  value: string
}

export default function CounterBox({label, value}: CounterBoxProps) {
  return (
    <div className="bg-base-200 text-base-content p-6 text-center rounded-lg border border-base-300 hover:border-base-content transition-all">
      <div className="text-lg font-medium text-base-content mb-2">{label}</div>
      <div className="text-5xl font-bold text-base-content">{value}</div>
    </div>
  )
}
